export default function isKaiserPharmacy(pharmacyName: string): boolean {
  return pharmacyName.toLowerCase().includes('kaiser');
}
